import React from 'react';
import './App.css';
import { TournamentChart } from './TournamentChart';
import { ChartFeedLandingPage } from './components/ChartFeedLandingPage';
import { loadLicensedWidgetRuntime } from './lib/chart/licensed-widget-loader';
import { isDummyAaplEnabled, isHarnessEnabled, isMobileIframeDemoEnabled } from './harness/is-harness-enabled';
import { PlayCanvasChartHarness } from './harness/PlayCanvasChartHarness';
import { DummyAaplChart } from './harness/DummyAaplChart';
import { MobileAaplIframeDemo } from './harness/MobileAaplIframeDemo';

function App() {
  // Early warm-up of licensed widget runtime for parallel vendor asset loading
  React.useEffect(() => {
    loadLicensedWidgetRuntime().catch(() => {});
  }, []);

  if (isHarnessEnabled()) {
    return <PlayCanvasChartHarness />;
  }

  if (isDummyAaplEnabled()) {
    return <DummyAaplChart />;
  }

  if (isMobileIframeDemoEnabled()) {
    return <MobileAaplIframeDemo />;
  }

  // Check if tournament mode is enabled via URL param
  const params = new URLSearchParams(window.location.search);
  const tournamentMode = params.get('tournament') === 'true' || params.has('tournamentId');

  if (tournamentMode) {
    // Full-screen tournament mode
    return <TournamentChart />;
  }

  return <ChartFeedLandingPage />;
}

export default App;
